import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

export const returnOrdersApi = createApi({
  reducerPath: 'returnOrders',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getReturnOrderNumber: builder.query({
      query: (subscriptionId) => ({
        method: 'GET',
        endpoint: `/subscriptions/${subscriptionId}/order_number`,
      }),
    }),
  }),
});

export const { useGetReturnOrderNumberQuery } = returnOrdersApi;
